<template>
  <div class="dn-be-notified">
    <atlas-button
      :class="isTagView ? 'secondary' : 'rounded secondary'"
      icon="common/alarm"
      :title="isTagView ? text : null"
      popovertarget="be-notified-modal"
      popovertargetaction="toggle"
      @click="openModal"
    />
    <AtlasPopoverModal
      id="be-notified-modal"
      :title="text"
    >
      <slot />
    </AtlasPopoverModal>
  </div>
</template>
<script setup lang="ts">
import { AtlasPopoverModal, AtlasButton } from '@nhst/ui';
import { useMobileAppsDetector } from '~/composables/useMobileAppsDetector';
import { useProfileLoginStore } from '~/store/profileLogin';

const mobileApps = useMobileAppsDetector();
const rtConfPub = useRuntimeConfig().public;
const isLoggedIn = ref(useProfileLoginStore().loginStatus.isLoggedIn);

defineProps({
  isTagView: {
    type: Boolean,
    required: false,
    default: false
  },
  text: {
    type: String,
    required: false,
    default: null
  }
});

const openModal = () => {
  if (import.meta.client && !isLoggedIn.value) {
    if ((mobileApps.isAndroid() || mobileApps.isIos()) && rtConfPub.name?.toLowerCase() === 'dn') {
      const link = document.createElement('a');
      link.href = '/auth/user/login';
      link.click();
    }
  }
};
</script>

<style lang="scss">
.dn-be-notified {
  .atlas-button {
    text-decoration: none;
  }
}
</style>
